import { MESSAGE_ANIMATION_DURATION } from "./utils/constants";

const NOWRAP = "nowrap !important";

export const getWrapperStyle = (isVisible: boolean) => ({
    position: "sticky",
    top: 0,
    zIndex: 10,
    width: "100%",
    transform: isVisible ? "translateY(0)" : "translateY(-100%)",
    transition: "transform 0.3s ease-in-out",
});

export const containerStyle = {
    height: "auto",
    justifyContent: "space-around",
    alignItems: "center",
    gap: 2,
};

export const getAnimatedContainerStyle = (isSaleSeason: boolean) => ({
    a: { color: isSaleSeason ? "white" : "black" },
    alignItems: "center",
    justifyContent: "center",
    display: "flex",
    overflow: "hidden",
    width: "100%",
    "*": {
        whiteSpace: NOWRAP, // Apply to all children to prevent wrapping
    },
    p: {
        py: [0, 1, 0.5],
        mb: 0,
        fontWeight: "bold",
        color: isSaleSeason ? "white" : "black",
        textAlign: "center",
        whiteSpace: NOWRAP, // Always nowrap for marquee - important to override RichText
        fontSize: ["desktopBodyTextTiny", "desktopBodyTextTiny", "desktopBodyTextSmall"],
        span: {
            whiteSpace: NOWRAP,
        },
    },
});

export const marqueeTrackStyle = {
    display: { base: "flex", sm: "none" }, // Show on mobile, hide on desktop
    overflow: "hidden",
    width: "100%",
};

export const marqueeContentStyle = {
    display: "flex",
    willChange: "transform",
    "@keyframes marquee": {
        "0%": {
            transform: "translateX(0)",
        },
        "100%": {
            transform: "translateX(-50%)",
        },
    },
};

export const staticMessageStyle = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
};

export const rotatingMessageContainerStyle = {
    display: { base: "none", sm: "flex" }, // Hide on mobile, show on desktop
    justifyContent: "center",
    alignItems: "center",
    w: "full",
    position: "relative",
    minHeight: "24px",
    "&:hover > *": {
        animationPlayState: "paused",
    },
};

export const getRotatingMessageStyle = (index: number, totalMessages: number) => {
    // If only one message, show it statically without animation
    if (totalMessages === 1) {
        return {
            textAlign: "center",
            opacity: 1,
            pointerEvents: "auto",
        };
    }

    const animationDuration = MESSAGE_ANIMATION_DURATION * totalMessages;
    const delayPerMessage = MESSAGE_ANIMATION_DURATION;
    const delay = index * delayPerMessage;

    return {
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
        textAlign: "center",
        animation: `fadeInOut ${animationDuration}s ease-in-out ${delay}s infinite`,
        opacity: 0,
        pointerEvents: "none",
        "@keyframes fadeInOut": {
            "0%": { opacity: 0, pointerEvents: "none" },
            "10%": { opacity: 1, pointerEvents: "auto" },
            [`${(1 / totalMessages) * 90}%`]: { opacity: 1, pointerEvents: "auto" },
            [`${(1 / totalMessages) * 100}%`]: { opacity: 0, pointerEvents: "none" },
        },
    };
};
